import * as actionTypes from '../actionTypes/userApplications';

export default {
  setUserApplications: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.SET_USER_APPLICATIONS,
      payload: params,
    };
    dispatch(actionData);
  },
  updateUserApplicationsBlobUrl: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPADTE_USER_APPLICATIONS_BLOBURL,
      payload: params,
    };
    dispatch(actionData);
  },
  setUserApplication: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.SET_USER_APPLICATION,
      payload: params,
    };
    dispatch(actionData);
  },
  updateUserApplication: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_USER_APPLICATION,
      payload: params,
    };
    dispatch(actionData);
  },
  updateUserAppLogBook: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_USER_APP_LOGBOOK,
      payload: params,
    };
    dispatch(actionData);
  },
  updateSingleApplication: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_SINGLE_APPLICATION,
      payload: params,
    };
    dispatch(actionData);
  },
  changeStatus: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.CHANGE_STATUS,
      payload: params,
    };
    dispatch(actionData);
  },
  updateTime: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_TIME,
      payload: params,
    };
    dispatch(actionData);
  },
  updateApp: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.UPDATE_APP,
      payload: params,
    };
    dispatch(actionData);
  },
  setBtnLoaderStudent: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.SET_BTN_LOADER_STUDENT,
      payload: params,
    };
    dispatch(actionData);
  },
  addReview: (params) => (dispatch) => {
    const actionData = {
      type: actionTypes.ADD_REVIEW,
      payload: params,
    };
    dispatch(actionData);
  },
  setStudentLogBookCommentRes: ({ partitionKey, status }) => ({
    type: actionTypes.SET_STUDENT_LOGBOOK_COMMENT_RES,
    payload: {
      partitionKey,
      status,
    },
  }),
  setSnackBarStateForActivityTab: ({
    showSnackBar,
    snackBarType,
    snackBarMessage,
  }) => ({
    type: actionTypes.SET_SNACKBAR_STATE_FOR_ACTIVITY_TAB,
    payload: {
      showSnackBar,
      snackBarType,
      snackBarMessage,
    },
  }),
};
